import React from 'react';
import { Modal, message, Space, Table } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import { openMiniPage } from '../../utils/open-mini-page';
import { getCurrentShopId } from '../shop/get-current-shop';

const pageMap = {
    index: "/pages/index/index",
    goodsDetail: "/pages/goods-detail/index",
    goodsList: "/pages/goods-list/index",
    couponList: "/pages/coupon-list/index",
    couponDetail: "/pages/coupon-tmp-detail/index",
    custom: "/pages/operation/index",
}

export default () => {

    const [dataSource, setDataSource] = React.useState([]);
    const columns = [
        {
            title: '名称',
            dataIndex: 'title',
        },
        {
            title: '操作',
            dataIndex: 'code',
            render: (code, record) => {
                return (
                    <Space>
                        <a href={`/mall/page/edit?pageId=${record.pageId || ''}`}>装修</a>
                        {code && <a onClick={() => openPage(code, record.shopId, record.pageId)}>查看</a>}
                        {record?.code === 'custom' && <a onClick={() => viewQRcode(record.pageId)}><QrcodeOutlined /></a>}
                    </Space>
                )
            }
        },
    ];

    const viewQRcode = async (pageId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/shop/get-page-qrcode?pageId=${pageId}&shopId=${shopId}`);
        const result = await res.json();
        if (result && result.success) {
            Modal.info({
                icon: null,
                title: '客户分享二维码',
                content: <div style={{textAlign: 'center'}}><img src={`https://img.yxdj.tech/${result.data.url}`} style={{width: 200}} /></div>,
            });
        }
    }

    const getPageList = async () => {
        
        const response = await fetch('/api/page/list');
        const result = await response.json();
        const rows = result?.data?.rows || [];

        if (result?.success) {
            setDataSource(rows);
        } else {
            message.error(result.data);
        }
    }

    const openPage = async (code, shopId, pageId) => {
        const accId = window.__baseInfo?.accId;
        const path = pageMap[code];
        if (!path) {
            message.error('页面不存在');
            return;
        }
        await openMiniPage(accId, path, { pageId, shopId });
    }

    React.useEffect(() => {
        getPageList();
    }, [])
    
    const renderMobileCardList = () => {
        return (
            <div className="space-y-3">
                {dataSource.map((item) => (
                    <div key={item.pageId} className="admin-card p-4 active:scale-[0.98] transition-transform">
                        {/* 头部：名称 */}
                        <div className="mb-3">
                            <h3 className="font-semibold text-text-primary">{item.title}</h3>
                        </div>
                        
                        {/* 操作按钮 */}
                        <div className="flex flex-wrap gap-2 justify-end pt-3 border-t border-border-light">
                            <a href={`/mall/page/edit?pageId=${item.pageId || ''}`} className="text-primary text-sm hover:underline">装修</a>
                            {item.code && (
                                <a onClick={() => openPage(item.code, item.shopId, item.pageId)} className="text-primary text-sm hover:underline">查看</a>
                            )}
                            {item?.code === 'custom' && (
                                <a onClick={() => viewQRcode(item.pageId)} className="text-primary text-sm hover:underline">
                                    <QrcodeOutlined />
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div>
            <div className="hidden md:block">
                <Table rowKey='pageId' columns={columns} dataSource={dataSource} />
            </div>
            <div className="md:hidden">
                {renderMobileCardList()}
            </div>
        </div>
    )
};